import React from 'react';

const UpgradeNudgeEmailSupport = () => (
  <svg fill="none" width="100%" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <g filter="url(#filter0_d)">
        <path
          d="M38 66.8182C38 61.948 41.948 58 46.8182 58H430.182C435.052 58 439 61.948 439 66.8182V244.182C439 249.052 435.052 253 430.182 253H46.8182C41.948 253 38 249.052 38 244.182V66.8182Z"
          fill="white"
        />
      </g>
      <rect
        fill="#F2F2F2"
        height="17"
        rx="4.40909"
        transform="matrix(1 0 0 -1 135 125)"
        width="294"
      />
      <rect
        fill="#F2F2F2"
        height="13.2273"
        rx="4.40909"
        width="65.2545"
        x="135"
        y="86.2178"
      />
      <rect
        fill="#F2F2F2"
        height="88"
        rx="4.40909"
        width="294"
        x="135"
        y="145"
      />
      <path
        clipRule="evenodd"
        d="M86.6667 80C71.9467 80 60 91.9467 60 106.667C60 121.387 71.9467 133.333 86.6667 133.333C101.387 133.333 113.333 121.387 113.333 106.667C113.333 91.9467 101.387 80 86.6667 80ZM86.6667 88C91.0933 88 94.6667 91.5733 94.6667 96C94.6667 100.427 91.0933 104 86.6667 104C82.24 104 78.6667 100.427 78.6667 96C78.6667 91.5733 82.24 88 86.6667 88ZM70.6667 117.28C74.1067 122.453 80 125.867 86.6667 125.867C93.3333 125.867 99.2267 122.453 102.667 117.28C102.587 111.973 91.9733 109.067 86.6667 109.067C81.3333 109.067 70.7467 111.973 70.6667 117.28Z"
        fill="#2655BD"
        fillRule="evenodd"
      />
      <g filter="url(#filter1_d)">
        <path
          d="M12 -153.182C12 -158.052 15.948 -162 20.8182 -162H340.182C345.052 -162 349 -158.052 349 -153.182V28.1818C349 33.052 345.052 37 340.182 37H20.8182C15.948 37 12 33.052 12 28.1818V-153.182Z"
          fill="white"
          fillOpacity="0.7"
        />
      </g>
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="203.818"
        id="filter0_d"
        width="409.818"
        x="33.5909"
        y="55.7955"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2.20455" />
        <feGaussianBlur stdDeviation="2.20455" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="207.818"
        id="filter1_d"
        width="345.818"
        x="7.59091"
        y="-164.205"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2.20455" />
        <feGaussianBlur stdDeviation="2.20455" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
      <clipPath id="clip0">
        <rect fill="white" height="280" width="419" />
      </clipPath>
    </defs>
  </svg>
);

export default UpgradeNudgeEmailSupport;
